import { MAGIC_LINK_PRESET_STORAGE_KEY } from '../hooks/useMagicLinkContribution';
import { noEntrarConFaceIdTrasCerrarSesion } from '../movil/cerrarSesion';

export const clearContextAndLocalStorage = () => {
	// Limpiar todo el LocalStorage
	// localStorage.clear();

	// Inicializo las variables del localStorage a vacío
	localStorage.setItem('companyId', '');
	localStorage.setItem('userId', '');
	localStorage.setItem('userAccountType', '');
	localStorage.setItem('language', '');
	localStorage.setItem('token', '');

	// El modal pendiente del enlace del correo vale para todo el navegador (chirigota#630): no
	// se le queda a quien entre después.
	localStorage.removeItem(MAGIC_LINK_PRESET_STORAGE_KEY);

	// En la app, el login que viene detrás no vuelve a entrar solo con la cara. Va aquí y no en
	// cada botón: así lo hace TODO cierre de sesión (panel, alta terminada o cancelada…). En la web
	// no hace nada.
	noEntrarConFaceIdTrasCerrarSesion();
};
